import React, { useLayoutEffect, useRef } from "react";
import CommentForm from "./CommentForm";
import { usePdfHighlighterContext } from "react-pdf-highlighter-extended";
import "./style/ExpandableTip.css";

const ExpandableTip = ({ addHighlight }) => {
  const selectionRef = useRef(null);

  const {
    getCurrentSelection,
    removeGhostHighlight,
    setTip,
    updateTipPosition,
  } = usePdfHighlighterContext();

  useLayoutEffect(() => {
    updateTipPosition();
  }, [updateTipPosition]);

  return (
    <div className="Tip">
      <CommentForm
        placeHolder="Enter Comment"
        onSubmit={(input) => {
          selectionRef.current = getCurrentSelection();
          addHighlight(
            {
              content: selectionRef.current.content,
              position: selectionRef.current.position,
            },
            input
          );

          removeGhostHighlight();
          setTip(null);
        }}
      />
    </div>
  );
};

export default ExpandableTip;
